import React from "react";

import * as galleryActions from "modules/gallery/actionCreator";
import * as adminLayoutActions from "modules/adminLayout/actionCreator";

import { NewsletterDetails, NewsletterFutureIssueDetailModel, NewsletterTemplateImageType } from "../../models";
import { GlobalApplicationState } from "globalApplicationState";
import { ConnectedProps, connect } from "react-redux";
import { HeaderAndFooter } from "modules/newsletters/edit/components/headerAndFooter";

import './styles.sass';

const HeaderAndFooterNewsletterIssueComponent: React.FunctionComponent<PropsWithRedux> = ({
    issue,
    newsletter,
    activeLcid,
    defaultLcid,
    isLoadingFooterImage,
    isLoadingHeaderImage,
    headerImage,
    footerImage,
    setMainStyle,
    setHeaderStyle,
    onError,
    onSetImage,
    onChange
}) => {
    const onChangeFooterText = (newFooter: string) => {
        let newContent = issue.translatedContent;
        newContent[activeLcid].footer = newFooter;
        onChange({ ...issue, translatedContent: newContent });
    }

    const onChangeHeaderText = (newHeader: string) => {
        let newContent = issue.translatedContent;
        newContent[activeLcid].header = newHeader;
        onChange({ ...issue, translatedContent: newContent });
    }

    const onChangeBodyText = (newBody: string) => {
        let newContent = issue.translatedContent;
        newContent[activeLcid].body = newBody;
        onChange({ ...issue, translatedContent: newContent });
    }

    const onFullscreen = (isFullscreen: boolean) => {
        if (isFullscreen) {
            // one more than side nav bar
            setMainStyle({ zIndex: 3 });
            setHeaderStyle({ display: "none" });
        } else {
            setMainStyle(undefined);
            setHeaderStyle(undefined);
        }
    }

    return (
        <>
            <div className="newsletter-issue-section">
                <HeaderAndFooter
                    headerImage={headerImage}
                    footerImage={footerImage}
                    isLoadingFooterImage={isLoadingFooterImage}
                    isLoadingHeaderImage={isLoadingHeaderImage}
                    setImage={onSetImage}
                    onError={onError} 
                    isCustomTemplate={newsletter.emailTemplateIsCustom} 
                    headerImageHeight={newsletter.emailTemplate?.headerImageHeight || 0} 
                    headerImageWidth={newsletter.emailTemplate?.headerImageWidth || 0} 
                    footerImageHeight={newsletter.emailTemplate?.footerImageHeight || 0} 
                    footerImageWidth={newsletter.emailTemplate?.footerImageWidth || 0} 
                    header={issue.translatedContent[activeLcid].header || ""} 
                    footer={issue.translatedContent[activeLcid].footer || ""} 
                    body={issue.translatedContent[activeLcid].body || ""} 
                    defaultLcid={defaultLcid} 
                    onBodyChange={onChangeBodyText} 
                    onHeaderChange={onChangeHeaderText} 
                    onFooterChange={onChangeFooterText} 
                    onFullscreen={onFullscreen}                    
                />
            </div>
        </>
    );
}

interface HeaderAndFooterNewsletterIssueProps {
    issue: NewsletterFutureIssueDetailModel;
    newsletter: NewsletterDetails;
    footerImage: File | null;
    headerImage: File | null;
    isLoadingFooterImage?: boolean;
    isLoadingHeaderImage?: boolean;
    onError: (message: string) => any;
    onChange: (issue: NewsletterFutureIssueDetailModel) => void;
    onSetImage: (imageType: NewsletterTemplateImageType, image?: File) => void;
    activeLcid: string;
}

const connector = connect(
    (state: GlobalApplicationState, ownProps: HeaderAndFooterNewsletterIssueProps) => ({
        ...ownProps,
        defaultLcid: state.settings.tenantSettings.defaultLCID,
    }),
    {
        getImage: galleryActions.getImage,
        setMainStyle: adminLayoutActions.setMainStyle,
        setHeaderStyle: adminLayoutActions.setHeaderStyle
    }
);

type PropsWithRedux = ConnectedProps<typeof connector>;
export const HeaderAndFooterNewsletterIssue = connector(HeaderAndFooterNewsletterIssueComponent);
